const accordions = document.querySelectorAll('.accordion');

accordions.forEach((accordion) => {
  const toggle = accordion.querySelector('.accordion__toggle');

  toggle.addEventListener('click', () => {
    const isOpen = accordion.getAttribute('aria-expanded') === 'true';

    isOpen
      ? accordion.setAttribute('aria-expanded', 'false')
      : accordion.setAttribute('aria-expanded', 'true');
  });
});

console.log('bite');
